import * as React from "react";
import * as LogoText from "src/assets/logos/precatorios-brasil/logo.svg";
import { Form, Row, Col, notification } from "antd";
import StandardButton from "src/components/common/StandardButton/StandardButton";
import { FormComponentProps } from "antd/lib/form";
import { AuthContext } from "src/components/context/AuthContext";
import ConfirmPassword from "src/pages/login/ConfirmPassword";
import { ContainerWrapper } from 'src/components/common/ContainerWrapper/ContainerWrapper';
import { Arrow } from 'src/components/common/Icons';
import { PbrCard } from 'src/components/common/PbrCard/PbrCard';

function RequestRecoveryCode(
  props: FormComponentProps & {
    onConfirmed: (newPassword: string) => void;
    user: any;
    pass: string;
  }
) {
  const [newPass, setNewPass] = React.useState("");
  const authContext = React.useContext(AuthContext);

  const [loading, setLoading] = React.useState(false);
  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    props.form.validateFieldsAndScroll({ scroll: { offsetTop: 150 } }, async errs => {
      if (!errs) {
        setLoading(true);

        try {
          await authContext.completeNewPassword(props.user, newPass);
          props.onConfirmed(newPass);
        } catch (error) {
          console.error(error);
          notification.error({
            message: "Não possível alterar a senha.",
            description: "Um erro ocorreu durante a tentiva de alteração de senha. Por favor tente novamente."
          });
          setLoading(false);
        }
      }
    });
  }

  return (
    <ContainerWrapper className="login">
      <div className="content-align">
        <PbrCard style={{ padding: "30px" }}>
          <Row align="middle" justify="center">
            <Col className="preca-br-logo">
              <div className="logo">
                <img src={LogoText} />
                <span className="portal-text">parceiros</span>
              </div>
            </Col>
          </Row>
          <h2 className="decode-login__title">Crie uma nova senha.</h2>
          <Arrow styles={{ width: "20px", position: "relative", left: "calc(99%/2)", transform: "translateX(-49%) rotate(90deg)", fill: "#3d81ff" }} />
          <Form onSubmit={e => handleSubmit(e)} className="login-form">
            <ConfirmPassword form={props.form} onChange={e => setNewPass(e.target.value)} label="Nova senha" placeholder="Digite a sua nova senha" />

            <Row className="actions-btn-row">
              <Col xs={24} sm={24} md={24} lg={24}>
                <StandardButton block loading={loading} onClick={e => handleSubmit(e)}>
                  Criar
                </StandardButton>
              </Col>
            </Row>
          </Form>
        </PbrCard>
      </div>
    </ContainerWrapper>
  );
}

export default Form.create()(RequestRecoveryCode);



// WEBPACK FOOTER //
// ./src/pages/login/RequestRecoveryCode.tsx